import { CDN2 } from '@/helpers/api';
import { basicPageProps } from '@/utils/isServer';
import { GetServerSideProps } from 'next';
import Head from 'next/head';
import React from 'react';
import HeroSection from '@/components2/PartnerUs/HeroSection';
import OurPartners from '@/components2/PartnerUs/OurPartners';
import Onboarding from '@/components2/PartnerUs/Onboarding';
import Affiliate from '@/components2/PartnerUs/Affiliate';
import Creators from '@/components2/PartnerUs/Creators';
import Leadership from '@/components2/PartnerUs/Leadership';
import FAQ from '@/components2/PartnerUs/FAQ';
import BlogPost from '@/components2/PartnerUs/BlogPost';
import { Breadcrumb } from 'antd';


export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const { airports } = await basicPageProps(ctx);

  return {
    props: {
      airports,
    },
  };
};

function Partner() {
  return (
    <div>
      <Head>
        <title>Partner with On Air Parking | On Air Parking</title>
        <meta
          name="description"
          content="We believe the only way to create partnerships is through win-win relatitonships. Partner with On Air Parking."
          key="description"
        />
        <meta
          property="og:url"
          content="https://www.onairparking.com/partner"
          key="og:url"
        />
        <meta property="og:type" content="website" key="og:type" />
        <meta
          property="og:title"
          content="Partner with On Air Parking | On Air Parking"
          key="og:title"
        />
        <meta
          property="og:description"
          content="We believe the only way to create partnerships is through win-win relatitonships. Partner with On Air Parking."
          key="og:description"
        />
        <meta
          property="og:image"
          content={CDN2() + '/staticmyapp/oglogo-white.png'}
          key="og:image"
        />
      </Head>
      <div className="mx-auto px-4 z-10">
        <Breadcrumb className="px-4 md:px-32 xl:px-4 mx-auto w-full flex max-w-7xl py-4">
          <Breadcrumb.Item>
            <a href="/">Home</a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            Partner with us
          </Breadcrumb.Item>
        </Breadcrumb>
        <HeroSection />

        <OurPartners />

        <Onboarding />

        <Affiliate />

        <Creators />

        <Leadership />

        <FAQ />

        <BlogPost />

      </div>
    </div>
  );
}

export default Partner;
